import React, { useEffect, useState } from 'react'
import { Link, NavLink, withRouter } from 'react-router-dom'
import { Badge, Popover, Row, Col, Spin, Avatar, message } from 'antd'

import './EducationInvestHeader.scss'
import logo from '../../../assets/images/LogoExitFund.svg'
import mobileLogo from '../../../assets/images/scouts/logo.png'
import empty_notification_icon from '../../../assets/images/scouts/empty_notification_icon.svg'
import { Container, Nav, Navbar } from 'react-bootstrap'
import Bell from '../../../assets/images/education/bell.svg'
import ProfileToggle from '../../../pages/EducationPortal/LearnInvest/EducationInvestProfile/ProfileToggle'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchProfileData,
  fetchUnreadNotificationCount,
  fetchUnreadNotifications,
  clearNotifications,
  updateHeaderLoaderStatus,
  checkPaymentStatus,
  updateCourseBoughtStatus,
} from '../../../redux/EducationLearnInvest/EducationLearnInvestActions'
import moment from 'moment'

const HeaderScout = props => {
  const dispatch = useDispatch()
  const profileData = useSelector(state => state?.educationLearnInvest?.profile_data)
  const { isCourseBought } = useSelector(state => state?.educationLearnInvest)
  const unread_notification_count = useSelector(
    state => state?.educationLearnInvest?.unread_notification_count,
  )
  const unreadNotifications = useSelector(state => state?.educationLearnInvest?.unreadNotifications)
  const loading = useSelector(state => state?.educationLearnInvest?.loading)
  const [unread, setUnread] = useState(0)
  const [logoutLoader, setLogoutLoader] = useState(false)

  useEffect(() => {
    setUnread(unread_notification_count)
  }, [unread_notification_count])

  /**
   * Fetches profile data and unread notification count if missing; redirects to suspend page on specific auth errors.
   */
  useEffect(() => {
    if (!profileData || Object.keys(profileData)?.length <= 0) {
      dispatch(
        fetchProfileData(
          res => {},
          err => {
            if (err == 'user logged out' || err == 'user is paused') {
              props.history.replace('/suspend')
              return
            }
          },
        ),
      )
    }
    dispatch(
      fetchUnreadNotificationCount(
        res => {},
        err => {
          if (err == 'user logged out' || err == 'user is paused') {
            props.history.replace('/suspend')
            return
          }
        },
      ),
    )
  }, [profileData])

  const VisibleChangeHandler = visiblity => {
    if (!visiblity) {
      setUnread(0)
    }
  }

  /**
   * Navigates to the given path if the course is purchased; otherwise, shows the purchase modal.
   */
  const handleNavClick = path => {
    if (!isCourseBought && path !== '/education/learn-invest/syllabus') {
      if (props?.location.pathname === '/education/learn-invest/course-details') {
        // do nothing
      } else {
        dispatch(updateHeaderLoaderStatus(true))
        dispatch(
          checkPaymentStatus(
            res => {
              if (res?.payment_status === 'successful') {
                message.success('Payment Successful')
                dispatch(updateCourseBoughtStatus(true))
                dispatch(updateHeaderLoaderStatus(false))
              } else if (res?.payment_status === 'processing') {
                props.history.push('/education/get-accredited/course-details')
              } else if (res?.payment_status === 'error') {
                dispatch(updateHeaderLoaderStatus(false))
                props.setShowPurchaseModal(true)
              } else if (res?.payment_status === 'uninitiated') {
                dispatch(updateHeaderLoaderStatus(false))
                props.setShowPurchaseModal(true)
              } else {
                dispatch(updateHeaderLoaderStatus(false))
                props.setShowPurchaseModal(true)
              }
            },
            err => {
              message.error('Something went wrong while checking payment status')
              dispatch(updateHeaderLoaderStatus(false))
            },
          ),
        )
      }
    } else {
      props.history.push(path)
    }
  }

  const onNotificationClick = async () => {
    await dispatch(fetchUnreadNotifications())
  }

  const onClearNotification = async () => {
    await dispatch(clearNotifications())
  }

  /**
   * Renders the notifications panel with loading state, list of unread notifications, and controls to clear or view all.
   */
  const notifications = (
    <div className="notifications-content-wrapper">
      <>
        {loading && (
          <div
            style={{
              position: 'absolute',
              zIndex: 100,
              display: 'flex',
              width: '100%',
              height: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: 0.4,
              background: 'white',
            }}
          >
            <Spin />
          </div>
        )}
        <div className="pop-header">
          <h4>Notification</h4>
          <span className="clear-all" onClick={onClearNotification}>
            Clear all
          </span>
        </div>
        <div className="pop-content">
          {unreadNotifications?.map(item => (
            <div className="line-hr">
              <Row gutter={12}>
                <Col span={4}>
                  <div className="alignments">
                    <Avatar src={item?.profile_pic}>{item?.first_name?.[0]?.toUpperCase() || 'E'}</Avatar>
                  </div>
                </Col>
                <Col span={18}>
                  <div className="alignments">
                    <span className="notification-msg">{item?.activity}</span>
                    <span className="timing">{moment(item?.timestamp).utc(true).fromNow()}</span>
                  </div>
                </Col>
              </Row>
            </div>
          ))}
        </div>
        <div className="pop-footer">
          <span
            onClick={() => {
              setUnread(0)
              props.history.push('/education/learn-invest/notifications')
            }}
          >
            View All
          </span>
        </div>
      </>
    </div>
  )

  /**
   * Renders the UI for when there are no new notifications, with a header and a link to view all notifications.
   */
  const emptyNotificationContent = (
    <>
      {loading && (
        <div
          style={{
            position: 'absolute',
            zIndex: 100,
            display: 'flex',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0.4,
            background: 'white',
          }}
        >
          <Spin />
        </div>
      )}
      <div className="empty-education-nootification-content-wrap">
        <div className="pop-header">
          <h4>Notification</h4>
          <span
            className="clear-all"
            onClick={() => props.history.push('/education/learn-invest/notifications')}
          >
            View all
          </span>
        </div>
        <div className="pop-content">
          <img src={empty_notification_icon} alt="" />
          <span className="no-notification-text">No new notifications</span>
        </div>
      </div>
    </>
  )

  return (
    <>
      {logoutLoader && (
        <div
          style={{
            position: 'absolute',
            zIndex: 1200,
            display: 'flex',
            width: '100%',
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 1,
            background: 'white',
          }}
        >
          <Spin />
        </div>
      )}
      <div className="toolbar sticky-top w-100">
        <div className="header m-0">
          <Navbar expand="lg" className="w-100 ">
            <Container className="headerTop" fluid>
              <Navbar.Brand className="left">
                <NavLink style={{ textDecoration: 'none' }} to="/education/learn-invest/syllabus">
                  <div className="logo" id="home-logo">
                    <img
                      src={logo}
                      className="d-none d-md-flex"
                      alt="Logo - Exitfund"
                      style={{ height: '45px', width: 'auto' }}
                    />
                    <img src={mobileLogo} className="d-md-none d-flex mobile-logo" alt="logo" />
                  </div>
                </NavLink>
              </Navbar.Brand>
              <div className="d-none d-md-flex">
                <Navbar id="basic-navbar-nav" className="d-md-flex d-sm-block justify-content-center">
                  <Nav className="d-flex justify-content-center">
                    <Nav
                      className={`text-dark px-2 ${
                        props?.location?.pathname === '/education/learn-invest/syllabus' ? 'active' : ''
                      }`}
                      onClick={() => handleNavClick('/education/learn-invest/syllabus')}
                    >
                      Syllabus
                    </Nav>
                    <Nav
                      className={`text-dark px-2 ${
                        props?.location?.pathname === '/education/learn-invest/exams' ? 'active' : ''
                      }`}
                      onClick={() => handleNavClick('/education/learn-invest/exams')}
                      style={
                        !isCourseBought &&
                        props?.location?.pathname === '/education/learn-invest/course-details'
                          ? { cursor: 'not-allowed' }
                          : {}
                      }
                    >
                      Exams
                    </Nav>
                  </Nav>
                </Navbar>
              </div>
              <div className="d-flex align-items-center right" style={{ position: 'relative' }}>
                <Popover
                  arrowContent={null}
                  content={unreadNotifications?.length > 0 ? notifications : emptyNotificationContent}
                  placement="bottomRight"
                  trigger="click"
                  overlayClassName="notifications-popover-container-education"
                  onVisibleChange={visiblity => VisibleChangeHandler(visiblity)}
                  align={{
                    offset: [2, 4],
                  }}
                  getPopupContainer={() => document.body}
                >
                  <Badge count={unread} className="mr-3" onClick={() => onNotificationClick()}>
                    <img src={Bell} alt="" />
                  </Badge>
                </Popover>
                <ProfileToggle profileData={profileData} setLogoutLoader={setLogoutLoader} />
              </div>
            </Container>
          </Navbar>
        </div>
      </div>
    </>
  )
}

export default withRouter(HeaderScout)
